export default __webpack_public_path__ + "static/media/01_Kom_Neumarkt.bb7c0b1f.jpg";